// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*---Header Stylesheet---*/
/*---General---*/

body{
	width: 1200px;
	text-align: center;
	margin: auto;
	margin-top: 15px;
}
a{
	text-decoration:none;
	color: black;
}

ul{
	list-style: none;
}

/*---Classes---*/

	.flex-container
	{
		display: flex;
		justify-content: space-around;
		align-items: center;
	}

	.logoIcon
	{
		align-items: center;
	}
	.tvaIcon
	{
		align-items: center;
	}
	.vwlogoIcon
	{
		align-items: center;
	}

	.details
	{
		text-align: center;
	}

/*---Responsive---*/

@media screen and (max-width:1200px)
{
	body
	{
		width: 100%;
		overflow-x:hidden;
		text-align: center;
	}
	
	img{
		width: 75px;
	}
	.vwlogoIcon img{
		width: 125px;
	}
	.tvaIcon img{
		width: 100px !important;
	}
	
	
	.logoIcon{
		display: block;
		text-align: center;
	}
	.tvaIcon{
		display: block;
		text-align: center;
	}

	.vwlogoIcon{
		display: block;
		text-align: center;
	}

	.flex-container{
		display: block;
		margin: 15px 0px 15px 20px;
	}
	
	.flex-container > div {
		margin: 10px 0 10px 0;
	}
	
	.marginLeft{
		margin-left: 10px;
	}
	
	.details{
		text-align: left;
	}
	
	.details >p {
		margin-left: 50px;
		font-size: 13px;
	}
}

@media screen and (max-width:850px)
{
	body
	{
		width: 100%;
		overflow-x:hidden;
	}
	
	.logoIcon >img{
		width: 75px;
	}

	.sponsorLogo
	{
		width: 100px!important; 
	}

	.rightLogo{
		width: 75px !important;
	}
	
	.logoIcon{
		display: block;
		text-align: center;
	}
	
	.flex-container{
		display: block;
		margin: 15px 0px 15px 20px;
	}

	.mobile-container{
		margin: 20px;
	}
	
	.flex-container > div {
		margin: 10px 0 10px 0;
	}
	
	.marginLeft{
		margin-left: 10px;
	}
	
	.details{
		text-align: left;
	}
	
	.details >p {
		margin-left: 50px;
		font-size: 13px;
	}
}

@media screen and (max-width: 600px)
{
	body
	{
		width:100%;
	}
	
	img{
		width: 50px;
	}
	
	.logoIcon{
		display: block;
		text-align: center;
	}
	
	.logoIcon p{
		margin: 0;
	}
	
	.detailsImg{
		float: left;
	}
	
	.flex-container{
		display: block;
		text-align: left;
		margin: 15px 0px 15px 20px;
	}
	
	.flex-container > div {
		margin: 10px 0 10px 0;
	}
	
	.marginLeft{
		margin-left: 10px;
	}
	
	.details{
		text-align: left;
	}
	
	.details >p {
		margin-left: 50px;
		font-size: 13px;
	}
}

@media screen and (max-width: 425px)
{
	body
	{
		max-width: 425px;
	}
	
	img{
		width: 75px;
	}
	
	label{
		margin-right: 15px;
	}
	
	.detailsImg{
		float: left;
	}
	
	.logoIcon{
		display: block;
		text-align: center;
	}
	
	.flex-container{
		display: block;
		margin: 15px 0px 15px 20px;
	}
	
	.flex-container > div {
		margin: 10px 0 10px 0;
	}
	
	.marginLeft{
		margin-left: 10px;
	}
	
	.details{
		text-align: left;
	}
	
	.details >p {
		margin-left: 50px;
		font-size: 13px;
	}
	
	.detailsImg{
		text-align: left;
	}
}`, "",{"version":3,"sources":["webpack://./src/css/customStyle.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B,gBAAgB;;AAEhB;CACC,aAAa;CACb,kBAAkB;CAClB,YAAY;CACZ,gBAAgB;AACjB;AACA;CACC,oBAAoB;CACpB,YAAY;AACb;;AAEA;CACC,gBAAgB;AACjB;;AAEA,gBAAgB;;CAEf;;EAEC,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;CACpB;;CAEA;;EAEC,mBAAmB;CACpB;CACA;;EAEC,mBAAmB;CACpB;CACA;;EAEC,mBAAmB;CACpB;;CAEA;;EAEC,kBAAkB;CACnB;;AAED,mBAAmB;;AAEnB;;CAEC;;EAEC,WAAW;EACX,iBAAiB;EACjB,kBAAkB;CACnB;;CAEA;EACC,WAAW;CACZ;CACA;EACC,YAAY;CACb;CACA;EACC,uBAAuB;CACxB;;;CAGA;EACC,cAAc;EACd,kBAAkB;CACnB;CACA;EACC,cAAc;EACd,kBAAkB;CACnB;;CAEA;EACC,cAAc;EACd,kBAAkB;CACnB;;CAEA;EACC,cAAc;EACd,0BAA0B;CAC3B;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,iBAAiB;EACjB,eAAe;CAChB;AACD;;AAEA;;CAEC;;EAEC,WAAW;EACX,iBAAiB;CAClB;;CAEA;EACC,WAAW;CACZ;;CAEA;;EAEC,sBAAsB;CACvB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,cAAc;EACd,kBAAkB;CACnB;;CAEA;EACC,cAAc;EACd,0BAA0B;CAC3B;;CAEA;EACC,YAAY;CACb;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,iBAAiB;EACjB,eAAe;CAChB;AACD;;AAEA;;CAEC;;EAEC,UAAU;CACX;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,cAAc;EACd,kBAAkB;CACnB;;CAEA;EACC,SAAS;CACV;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,cAAc;EACd,gBAAgB;EAChB,0BAA0B;CAC3B;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,iBAAiB;EACjB,eAAe;CAChB;AACD;;AAEA;;CAEC;;EAEC,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,cAAc;EACd,kBAAkB;CACnB;;CAEA;EACC,cAAc;EACd,0BAA0B;CAC3B;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,iBAAiB;EACjB,eAAe;CAChB;;CAEA;EACC,gBAAgB;CACjB;AACD","sourcesContent":["/*---Header Stylesheet---*/\n/*---General---*/\n\nbody{\n\twidth: 1200px;\n\ttext-align: center;\n\tmargin: auto;\n\tmargin-top: 15px;\n}\na{\n\ttext-decoration:none;\n\tcolor: black;\n}\n\nul{\n\tlist-style: none;\n}\n\n/*---Classes---*/\n\n\t.flex-container\n\t{\n\t\tdisplay: flex;\n\t\tjustify-content: space-around;\n\t\talign-items: center;\n\t}\n\n\t.logoIcon\n\t{\n\t\talign-items: center;\n\t}\n\t.tvaIcon\n\t{\n\t\talign-items: center;\n\t}\n\t.vwlogoIcon\n\t{\n\t\talign-items: center;\n\t}\n\n\t.details\n\t{\n\t\ttext-align: center;\n\t}\n\n/*---Responsive---*/\n\n@media screen and (max-width:1200px)\n{\n\tbody\n\t{\n\t\twidth: 100%;\n\t\toverflow-x:hidden;\n\t\ttext-align: center;\n\t}\n\t\n\timg{\n\t\twidth: 75px;\n\t}\n\t.vwlogoIcon img{\n\t\twidth: 125px;\n\t}\n\t.tvaIcon img{\n\t\twidth: 100px !important;\n\t}\n\t\n\t\n\t.logoIcon{\n\t\tdisplay: block;\n\t\ttext-align: center;\n\t}\n\t.tvaIcon{\n\t\tdisplay: block;\n\t\ttext-align: center;\n\t}\n\n\t.vwlogoIcon{\n\t\tdisplay: block;\n\t\ttext-align: center;\n\t}\n\n\t.flex-container{\n\t\tdisplay: block;\n\t\tmargin: 15px 0px 15px 20px;\n\t}\n\t\n\t.flex-container > div {\n\t\tmargin: 10px 0 10px 0;\n\t}\n\t\n\t.marginLeft{\n\t\tmargin-left: 10px;\n\t}\n\t\n\t.details{\n\t\ttext-align: left;\n\t}\n\t\n\t.details >p {\n\t\tmargin-left: 50px;\n\t\tfont-size: 13px;\n\t}\n}\n\n@media screen and (max-width:850px)\n{\n\tbody\n\t{\n\t\twidth: 100%;\n\t\toverflow-x:hidden;\n\t}\n\t\n\t.logoIcon >img{\n\t\twidth: 75px;\n\t}\n\n\t.sponsorLogo\n\t{\n\t\twidth: 100px!important; \n\t}\n\n\t.rightLogo{\n\t\twidth: 75px !important;\n\t}\n\t\n\t.logoIcon{\n\t\tdisplay: block;\n\t\ttext-align: center;\n\t}\n\t\n\t.flex-container{\n\t\tdisplay: block;\n\t\tmargin: 15px 0px 15px 20px;\n\t}\n\n\t.mobile-container{\n\t\tmargin: 20px;\n\t}\n\t\n\t.flex-container > div {\n\t\tmargin: 10px 0 10px 0;\n\t}\n\t\n\t.marginLeft{\n\t\tmargin-left: 10px;\n\t}\n\t\n\t.details{\n\t\ttext-align: left;\n\t}\n\t\n\t.details >p {\n\t\tmargin-left: 50px;\n\t\tfont-size: 13px;\n\t}\n}\n\n@media screen and (max-width: 600px)\n{\n\tbody\n\t{\n\t\twidth:100%;\n\t}\n\t\n\timg{\n\t\twidth: 50px;\n\t}\n\t\n\t.logoIcon{\n\t\tdisplay: block;\n\t\ttext-align: center;\n\t}\n\t\n\t.logoIcon p{\n\t\tmargin: 0;\n\t}\n\t\n\t.detailsImg{\n\t\tfloat: left;\n\t}\n\t\n\t.flex-container{\n\t\tdisplay: block;\n\t\ttext-align: left;\n\t\tmargin: 15px 0px 15px 20px;\n\t}\n\t\n\t.flex-container > div {\n\t\tmargin: 10px 0 10px 0;\n\t}\n\t\n\t.marginLeft{\n\t\tmargin-left: 10px;\n\t}\n\t\n\t.details{\n\t\ttext-align: left;\n\t}\n\t\n\t.details >p {\n\t\tmargin-left: 50px;\n\t\tfont-size: 13px;\n\t}\n}\n\n@media screen and (max-width: 425px)\n{\n\tbody\n\t{\n\t\tmax-width: 425px;\n\t}\n\t\n\timg{\n\t\twidth: 75px;\n\t}\n\t\n\tlabel{\n\t\tmargin-right: 15px;\n\t}\n\t\n\t.detailsImg{\n\t\tfloat: left;\n\t}\n\t\n\t.logoIcon{\n\t\tdisplay: block;\n\t\ttext-align: center;\n\t}\n\t\n\t.flex-container{\n\t\tdisplay: block;\n\t\tmargin: 15px 0px 15px 20px;\n\t}\n\t\n\t.flex-container > div {\n\t\tmargin: 10px 0 10px 0;\n\t}\n\t\n\t.marginLeft{\n\t\tmargin-left: 10px;\n\t}\n\t\n\t.details{\n\t\ttext-align: left;\n\t}\n\t\n\t.details >p {\n\t\tmargin-left: 50px;\n\t\tfont-size: 13px;\n\t}\n\t\n\t.detailsImg{\n\t\ttext-align: left;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
